import React from 'react'
import { Card, Row, Col, Statistic, Space, Button, Tag } from 'antd'
import {
  MailOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  SyncOutlined,
  ThunderboltOutlined
} from '@ant-design/icons'
import { EmailSystemStatus } from '../interfaces/interfaces'
import { getQueueStatusColor, formatTimestamp } from '../utils/helpers'
import { WorkerConfigInfo } from '../styles'

interface QueueStatsProps {
  status: EmailSystemStatus | null
  onRetryFailed: () => void
}

export const QueueStats: React.FC<QueueStatsProps> = ({ status, onRetryFailed }) => {
  const queue = status?.queue
  const worker = status?.worker

  return (
    <Card
      title={
        <Space>
          <MailOutlined />
          Очередь писем (Email Queue)
        </Space>
      }
      extra={
        <Button type="primary" icon={<ThunderboltOutlined />} onClick={onRetryFailed}>
          Повторить неудачные
        </Button>
      }
      style={{ marginBottom: 16 }}
    >
      <Row gutter={16}>
        <Col span={4}>
          <Statistic title="Всего" value={queue?.total || 0} prefix={<MailOutlined />} />
        </Col>
        <Col span={4}>
          <Statistic
            title="Ожидают"
            value={queue?.pending || 0}
            prefix={<ClockCircleOutlined />}
            valueStyle={{
              color: getQueueStatusColor(queue?.pending || 0, queue?.failed || 0)
            }}
          />
        </Col>
        <Col span={4}>
          <Statistic
            title="Обрабатываются"
            value={queue?.processing || 0}
            prefix={<SyncOutlined spin={!!queue?.processing} />}
          />
        </Col>
        <Col span={4}>
          <Statistic
            title="Отправлено"
            value={queue?.sent || 0}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: 'green' }}
          />
        </Col>
        <Col span={4}>
          <Statistic
            title="Неудачных"
            value={queue?.failed || 0}
            prefix={<CloseCircleOutlined />}
            valueStyle={{ color: queue?.failed ? 'red' : undefined }}
          />
        </Col>
        <Col span={4}>
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 14, color: 'rgba(0,0,0,0.45)', marginBottom: 4 }}>Worker</div>
            <Tag color={worker?.isActive ? 'green' : 'red'} style={{ fontSize: 14 }}>
              {worker?.isActive ? '🟢 Активен' : '🔴 Остановлен'}
              {worker?.isProcessing ? ' (отправляет...)' : ''}
            </Tag>
          </div>
        </Col>
      </Row>

      {worker?.config && (
        <WorkerConfigInfo>
          <strong>Настройки worker:</strong> {worker.config.BATCH_SIZE} писем каждые{' '}
          {worker.config.INTERVAL_MS / 1000} сек (задержка {worker.config.DELAY_BETWEEN_EMAILS / 1000}{' '}
          сек между письмами)
        </WorkerConfigInfo>
      )}

      {queue?.oldestPending && (
        <div style={{ marginTop: 12, color: '#666', fontSize: 13 }}>
          Самое старое письмо: {formatTimestamp(queue.oldestPending)}
        </div>
      )}
    </Card>
  )
}

